<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :required="false"
              :vertical="false"
              optional
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="moduleCode"
              defaultOption="all"
              codeId="COD_MDLE"
              :pageId="this.$options.name"
              :selected="frame0.selectedCodeValue.COD_MDLE"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MSG_RESO_TYPE')"
              :required="false"
              :vertical="false"
              style="letter-spacing: -1px;"
              optional
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="messageResourcesTypeCode"
              :pageId="this.$options.name"
              defaultOption="all"
              :selected="frame0.selectedCodeValue.COD_MSG_RESO_TYPE"
              codeId="COD_MSG_RESO_TYPE"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <wbr>
            <sui-input-label
              :label="$t('MSG_TXT_LANG')"
              :required="false"
              :vertical="false"
              class="ls"
            />
          </div>
          <div class="col-xs-5">
            <sui-lang-select
              ref="langCode"
              :selected="frame0.selectedCodeValue.COD_LANG"
              :pageId="this.$options.name"
              defaultOption="all"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :required="false"
              :vertical="false"
              optional
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="searchCond"
              :pageId="this.$options.name"
              codeId="COD_MSG_RESO_SEARCH_COND"
              :selected="frame0.selectedCodeValue.COD_MSG_RESO_SEARCH_COND"
              defaultOption="all"
              :initialSelectedIndex="0"
              style="width:58%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              ref="searchField"
              v-model="frame0.codMsgResoSearchText"
              maxlength="50"
              @keyup.enter="onClickSearch('button')"
              @keyup="onKeyUpInput"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch('button')"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :dataset="'dsMessageResource'"
        :columns="columns"
        :showDisplayCountControl="false"
      />
      <div
        class="btn_moreView"
        @click="onAddList"
      >
        <p :class="paging.totalCount === 0 || paging.count === paging.totalCount ? 'disabled' : ''">
          {{ $t("MSG_TXT_SHOW_MORE") }} {{ showMoreCount }}
        </p>
      </div>
      <div class="mrB30" />
      <sui-page-tab-box-type
        :defaultTabIndex="defaultTabIndex"
        :tab-items="tabItems"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :massdataList="massdata"
          :messageResourcesId="messageResourcesId"
          :langId="langId"
          :messageResourcesMultiLanguageId="messageResourcesMultiLanguageId"
          :pageId="$options.name"
          :selectedData="selectedRowData"
          @deleted-message-resource="onDeletedMessageResource"
          @saved-message-resource="onSavedMessageResource"
          @onClickNew="onClickNew"
          @onPopupCall="onPopupCall"
          @page-deactivate="handleChildDeactivated"
          @page-activate="handleChildActivated"
        />
      </sui-page-tab-box-type>
      <sui-popup
        v-model="isShownPopupMasteNew"
        :title="$t('MSG_TXT_MSG_RESO_BK_RGST')"
      >
        <p01
          :pageId="this.$options.pname"
          @onClickCheck="onClickCheck"
          @onClickCancel="onClickCancel"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import tab01 from './components/PGE_CMU_00003_T01';
import tab02 from './components/PGE_CMU_00003_T02';
import tab04 from './components/PGE_CMU_00003_T04';
import tab03 from './components/PGE_CMU_00003_T03';
import p01 from './components/PGE_CMU_00003_P01';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const dateFields = [
  'firstRegistrationDTM', 'finalModificationDTM', 'pageUsePriodStartDatetime', 'pageUsePriodFinishDatetime',
];

export default {
  name: 'PGE_CMU_00003', // eslint-disable-line vue/name-property-casing
  components: {
    tab01, tab02, tab04, tab03, p01,
  },
  extends: BasePage,
  data() {
    return {
      paramData: null,
      multiTenancy: utils.getConfigurationValue('YML_MULTI_TENANCY_YN') === 'Y',
      isPaging: false,
      paging: {
        pagePerCount: 5000,
        currentPage: 1,
        totalCount: 0,
        count: 0,
      },
      pageTitle: this.$t('MSG_TXT_MSG_RESO'),
      tabItems: [
        { tabTitle: (this.$t('MSG_TXT_MSG_RESO')), tabComponent: 'tab01' },
        { tabTitle: (this.$t('MSG_TXT_PAGE')), tabComponent: 'tab02' },
        { tabTitle: (this.$t('MSG_TXT_CMPNT')), tabComponent: 'tab04' },
        { tabTitle: (this.$t('MSG_TXT_BK_RGST')), tabComponent: 'tab03' },
      ],
      frame0: {
        selectedCodeValue: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_MSG_RESO_TYPE: {
            label: '',
            key: '',
          },
          COD_MSG_RESO_SEARCH_COND: {
            label: '',
            key: '',
          },
          COD_LANG: {
            label: '',
            key: '',
          },
          useYnValue: {},
        },
        selectedRowData: [],
        codMsgResoSearchText: '',
      },
      selectedRowData: {},
      massdata: '',
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      isShownPopupMasteNew: false,
      messageResourcesId: '',
      langId: '',
      messageResourcesMultiLanguageId: '',
    };
  },
  computed: {
    // 계산된 속성, property로 사용가능
    showMoreCount() {
      return `(${this.paging.count}/${this.paging.totalCount})`;
    },
  },
  created() {
    this.localdata = [];
    this.columns = [{
      text: this.$t('MSG_TXT_MDLE'),
      datafield: 'moduleName',
      width: '100px',
    }, {
      text: this.$t('MSG_TXT_MSG_RESO_TYPE'),
      datafield: 'messageResourcesTypeName',
      width: '120px',
    }, {
      text: this.$t('MSG_TXT_MSG_RESO_ID'),
      datafield: 'messageResourcesId',
    }, {
      text: this.$t('MSG_TXT_LNG_ID'),
      datafield: 'langId',
      width: '80px',
    }, {
      text: this.$t('MSG_TXT_MSG_RESO_VAL'),
      datafield: 'multiLanguageContent',
    }, {
      text: this.$t('MSG_TXT_MSG_RESO_DEF_VAL'),
      datafield: 'defaultMultiLanguageContent',
      hidden: !this.multiTenancy,
    }, {
      text: this.$t('MSG_TXT_MDFC_USR'),
      datafield: 'finalModificationUserId',
      width: '200px',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
          displayType: '1', // "1", "2" - default: "1"
          type: 'link', // 'link', 'sublink' - default: "link"
          datafieldMap: {
            displayLanguageId: 'displayLanguageId',
            loginId: 'loginId',
            knoxId: 'knoxId',
            userId: 'finalModificationUserId',
            userName: 'userName',
            userGlobalName: 'userGlobalName',
            departmentName: 'departmentName',
            departmentEnglishName: 'departmentEnglishName',
          },
        }, this.dsMessageResource, this.$refs.grid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
    }, {
      text: this.$t('MSG_TXT_MDFC_DTM'),
      datafield: 'finalModificationDTM',
      width: '150px',
    }];
  },
  mounted() {
    this.dsMessageResource.$on(this.dsMessageResource.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
  },
  destroyed() {
    this.dsMessageResource.$off(this.dsMessageResource.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
  },
  methods: {
    /**
     * tab event
     */
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].tabComponent;
    },
    /**
     * 초기화
     */
    onClickReset() {
      const selectBoxRefs = ['moduleCode', 'messageResourcesTypeCode', 'searchCond', 'langCode'];
      utils.forEach(selectBoxRefs, values => {
        this.$refs[values].reset();
      });
      this.$refs.langCode.select('ALL');
      this.frame0.codMsgResoSearchText = '';
    },
    /**
     * 더보기
     */
    onAddList() {
      if (this.isPaging) {
        this.paging.currentPage += 1;
        this.selectMessageResources();
      }
    },
    /**
     * 검색
     */
    onClickSearch(key) {
      if (this.validationCheck()) return false;
      const codeValue = this.frame0.selectedCodeValue;
      const queryParams = {
        moduleCode: utils.trim(codeValue.COD_MDLE.key) || '',
        messageResourcesTypeCode: utils.trim(codeValue.COD_MSG_RESO_TYPE.key) || '',
        searchMsgResoCond: utils.trim(codeValue.COD_MSG_RESO_SEARCH_COND.key) || '',
        searchMsgResoText: utils.trim(this.frame0.codMsgResoSearchText) || '',
        lngId: utils.trim(codeValue.COD_LANG.key) || '',
      };

      this.queryParams = utils.clone(queryParams);

      this.paging.currentPage = 1;
      this.paging.totalCount = 0;
      this.paging.count = 0;

      this.dsMessageResource.setRawData([], { preventBackup: true });
      this.selectMessageResources(key);

      return null;
    },
    selectMessageResources(key) {
      utils.assign(this.queryParams, { currentPage: this.paging.currentPage, pagePerCount: this.paging.pagePerCount });
      http.request(this.$options.name, 'DTS_CMU_00067', {
        query: this.queryParams,
      }).then(res => {
        if (res.data.length > 0) {
          this.paging.totalCount = res.data[0].totalCount;
        }
        // 실제 사용하는 데이터만 필터링
        res.data = utils.getFilteredDataFromDataset(res.data, this.dsMessageResource, true);
        utils.dateformatToClientInArray(res.data, dateFields);

        // this.dsMessageResource.addRows(res.data);
        // this.dsMessageResource.submit();

        const { data } = this.dsMessageResource;
        // 기본 가이드
        const newData = [];
        utils.forEach(data, row => newData.push(row));
        utils.forEach(res.data, row => newData.push(row));
        this.dsMessageResource.setRawData(newData, { preventBackup: true });

        this.paging.count = this.dsMessageResource.data.length;
        if (!utils.isUndefined(res.data) && this.paging.count < this.paging.totalCount) {
          this.isPaging = true;

          if (res.data.length > 0 && utils.isEqual(this.paging.currentPage, 1) && utils.isEqual(key, 'button')) {
            this.dsMessageResource.clearSelection();
            this.dsMessageResource.setSelectedIndexes([0]);
          } else if (this.paramData != null) {
            this.$refs.grid.setSelect(this.paramData);
            this.paramData = null;
          }
        } else {
          this.isPaging = false;

          if (this.paramData != null) {
            this.$refs.grid.setSelect(this.paramData);
            this.paramData = null;
          }
        }
      });
    },
    /**
     * 조회 시 검색조건1개이상 필수 입력 체크
     */
    validationCheck() {
      const codeValue = this.frame0.selectedCodeValue;

      if (utils.isEqual(codeValue.COD_MDLE.key, 'ALL')
      && utils.isEqual(codeValue.COD_MSG_RESO_TYPE.key, 'ALL')
      && utils.isEmpty(this.frame0.codMsgResoSearchText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_MSG_SRCH'));
        return true;
      }
      return false;
    },
    /**
     * 신규
     */
    onClickNew() {
      this.dsMessageResource.clearSelection();
      this.selectedRowData = {};
      this.langId = '';
      this.messageResourcesId = '';
    },
    /**
     * 삭제 후 처리
     */
    onDeletedMessageResource() {
      this.onClickSearch();
    },
    /**
     * 수정 후 처리
     */
    onSavedMessageResource(paramData) {
      if (paramData != null) {
        this.paramData = paramData;
      }
      this.onClickSearch();
    },
    /**
     * 팝업 Event
     */
    onPopupCall() {
      this.isShownPopupMasteNew = true;
    },
    onClickCheck(value) {
      const valueSplitList = value.split('|');

      if (valueSplitList.length > 30) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_MAX_SEARCH_CNT'), '30'));
        return false;
      }
      this.massdata = value;
      this.isShownPopupMasteNew = false;

      return true;
    },
    onClickCancel() {
      this.isShownPopupMasteNew = false;
    },
    /**
     * grid selected event
     */
    datasetSelectionChanged(data) {
      if (!utils.isEmpty(data) && !utils.isEmpty(data.newSelections)) {
        this.selectedRowData = this.dsMessageResource.data[data.newSelections];
        this.langId = this.dsMessageResource.data[data.newSelections].langId;
        this.messageResourcesId = this.dsMessageResource.data[data.newSelections].messageResourcesId;
      }
    },
    /**
     * 검색조건 특수문자 입력 제한
     */
    onKeyUpInput() {
      const searchFieldNewText = this.frame0.codMsgResoSearchText;

      if (utils.isExistSpecialChar(searchFieldNewText)) {
        // utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR_SRCH'), this.$t('MSG_ALT_SPECL_CHAR_LIST'), () => {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.frame0.codMsgResoSearchText = this.searchFieldOldText;
          this.$refs.searchField.setFocus();
        });
      } else {
        this.searchFieldOldText = searchFieldNewText;
      }
    },
  },
  datasets: [{
    id: 'dsMessageResource',
    type: 'local',
    data: 'localdata',
    datafields: [
      { name: 'moduleCode', type: 'string', map: 'moduleCode' },
      { name: 'messageResourcesTypeCode', type: 'string', map: 'messageResourcesTypeCode' },
      { name: 'messageResourcesId', type: 'string', map: 'messageResourcesId' },
      { name: 'langId', type: 'string', map: 'langId' },
      { name: 'multiLanguageContent', type: 'string', map: 'multiLanguageContent' },
      { name: 'defaultMultiLanguageContent', type: 'string', map: 'defaultMultiLanguageContent' },
      { name: 'messageResourcesMultiLanguageId', type: 'string', map: 'messageResourcesMultiLanguageId' },
      { name: 'defaultMessageResourcesMultiLanguageId', type: 'string', map: 'defaultMessageResourcesMultiLanguageId' },
      { name: 'finalModificationUserId', type: 'string', map: 'finalModificationUserId' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'firstRegistrationDTM', type: 'string', map: 'firstRegistrationDTM' },
      { name: 'firstRegistrationUserId', type: 'string', map: 'firstRegistrationUserId' },
      { name: 'pageBasicsYn', type: 'string', map: 'pageBasicsYn' },
      { name: 'moduleName', type: 'string', map: 'moduleName' },
      { name: 'messageResourcesTypeName', type: 'string', map: 'messageResourcesTypeName' },
      { name: 'loginId', type: 'string', map: 'loginId' },
      { name: 'knoxId', type: 'string', map: 'knoxId' },
      { name: 'userName', type: 'string', map: 'userName' },
      { name: 'userGlobalName', type: 'string', map: 'userGlobalName' },
      { name: 'departmentName', type: 'string', map: 'departmentName' },
      { name: 'departmentEnglishName', type: 'string', map: 'departmentEnglishName' },
      { name: 'displayLanguageId', type: 'string', map: 'displayLanguageId' },
      { name: 'displayLanguageIdRegistration', type: 'string', map: 'displayLanguageIdRegistration' },
      { name: 'loginIdRegistration', type: 'string', map: 'loginIdRegistration' },
      { name: 'knoxIdRegistration', type: 'string', map: 'knoxIdRegistration' },
      { name: 'userNameRegistration', type: 'string', map: 'userNameRegistration' },
      { name: 'userGlobalNameRegistration', type: 'string', map: 'userGlobalNameRegistration' },
      { name: 'departmentNameRegistration', type: 'string', map: 'departmentNameRegistration' },
      { name: 'departmentEnglishNameRegistration', type: 'string', map: 'departmentEnglishNameRegistration' },
    ],
  }],
};
</script>
<style scoped>
</style>
